module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/football-964f54cd1f2bc6f36c63cfa5be8daa25.svg";